import type { SquareInfo } from "@/components/Game/GameGrid/SquareContent";
import type { GameThemeId } from "@skillscratch/shared-types";
import { useState, useCallback, useEffect } from "react";
import { getBonusScratches } from "@/helpers/getBonusScratches";


interface UseBonusScratchesProps {
    scratchesLeft: number;
    grid: SquareInfo[][];
    treasureFoundCount: number;
    cardName: GameThemeId;
    loseStreak: number;
    isStreakLoading: boolean;
    endGame: (reason: "no-scratch") => Promise<void>;
  }
  
  export function useBonusScratches({
    scratchesLeft,
    grid,
    treasureFoundCount,
    loseStreak,
    isStreakLoading,
    endGame
  }: UseBonusScratchesProps) {
    const [bonusScratches, setBonusScratches] = useState<number | null>(null);
    const [showBonusScratchesModal, setShowBonusScratchesModal] = useState(false);
  
    const activateBonusScratches = useCallback(() => {
      setShowBonusScratchesModal(false);
      return Date.now();
    }, []);
  
    useEffect(() => {
        if (scratchesLeft + (bonusScratches ?? 0) === 0 && grid.flat().every(s => s.type !== 'loading')) {
            if (isStreakLoading) {
                return;
            }   

            setBonusScratches(prevBonus => {
                const newBonusScratches = prevBonus === null 
                    ? getBonusScratches(treasureFoundCount, loseStreak) 
                    : 0;

                    if (newBonusScratches) {
                        setShowBonusScratchesModal(true);
                    } else {
                        endGame('no-scratch');
                    }
                    
                    return newBonusScratches;
            });
        }
    }, [scratchesLeft, grid, treasureFoundCount, isStreakLoading, loseStreak, endGame, bonusScratches]);
  
    return {
      bonusScratches,
      showBonusScratchesModal,
      activateBonusScratches,
    };
  }